import React from "react";
import InputMask from 'react-input-mask'
import './CalculatorSelectForm.scss'

interface ICalculatorSelectFormProps {
  image?: File
  models?: Array<string>
  motors?: Array<string>
  transmissions?: Array<string>
  drives?: Array<string>
  pms?: Array<string>
  selected: {
    model?: string
    motor?: string
    transmission?: string
    drive?: string
    pm?: string
  }
  pmData?: App.IObject
  select: (key: string, value: string) => void
  onInputChange: (name: string, value: any) => void
  writeForPMData: {
    surname: string
    name: string
    patronymic: string
    car_number: string
    phone: string
  }
  onPMWrite: () => void
}

export default class CalculatorSelectFormSelectForm extends React.Component<ICalculatorSelectFormProps, any> {

  getModelSelectOptions() : Array<JSX.Element> {
    let options: Array<JSX.Element> = [];

    this.props.models?.forEach((name, index) => {
      options.push((
        <option key={index + 1} value={name}>{name}</option>
      ))
    });

    return options;
  }

  getMotorSelectOptions() : Array<JSX.Element>  {
    let options: Array<JSX.Element> = [];

    if (this.props.selected.model && this.props.motors)
      this.props.motors.forEach((key, index) => {
        options.push((
          <option key={index + 1} value={key}>{key}</option>
        ))
      });

    return options;
  }

  getTransmissionSelectOptions() : Array<JSX.Element>  {
    let options : Array<JSX.Element> = [];

    if (this.props.selected.model && this.props.selected.motor && this.props.transmissions)
      this.props.transmissions.forEach((key, index) => {
        options.push((
          <option key={index + 1} value={key}>{key}</option>
        ))
      });

    return options;
  }

  getDriveSelectOptions() : Array<JSX.Element> {
    let options : Array<JSX.Element> = [];

    if (this.props.selected.model && this.props.selected.motor && this.props.selected.transmission && this.props.drives)
      this.props.drives.forEach((key, index) => {
        options.push((
          <option key={index + 1} value={key}>{key}</option>
        ))
      });

    return options;
  }

  getPMSelectOptions() : Array<JSX.Element> {
    let options : Array<JSX.Element> = [];

    if (this.props.selected.model && this.props.selected.motor && this.props.selected.transmission && this.props.selected.drive && this.props.pms)
      this.props.pms.forEach((key, index) => {
        options.push((
          <option key={index + 1} value={key}>{key}</option>
        ))
      });

    return options;
  }

  select(event: React.ChangeEvent<HTMLSelectElement>, key: string) {
    // @ts-ignore
    let name = event.target.value;
    this.props.select(key, name);
  }

  render() {
    let url = '';
    if (this.props.image)
      url = URL.createObjectURL(this.props.image);

    return <div className='calculator-select-form'>
      <div>
        <h3>Рассчитайте ТО</h3>
        <div className='car-image-container'>
          <img src={url} alt='Модель'/>
        </div>
        <div className='car-select-container'>
          <h5>Автомобиль</h5>
          <div>
            <select
              value={this.props.selected.model || 0}
              onChange={(event) => this.select(event, 'model')}
            >
              <option value={0} key={0} disabled={true} hidden={true}>Автомобиль</option>
              {this.getModelSelectOptions()}
            </select>
          </div>
          {
            this.props.selected.model ?
              <div>
                <select
                  value={this.props.selected.motor || 0}
                  onChange={(event) => this.select(event, 'motor')}
                >
                  <option value={0} key={0} disabled={true} hidden={true}>Двигатель</option>
                  {this.getMotorSelectOptions()}
                </select>
              </div>
              :
              <></>
          }
          {
            this.props.selected.model &&
              this.props.selected.motor ?
                <div>
                  <select
                    value={this.props.selected.transmission || 0}
                    onChange={(event) => this.select(event, 'transmission')}
                  >
                    <option value={0} key={0} disabled={true} hidden={true}>КПП</option>
                    {this.getTransmissionSelectOptions()}
                  </select>
                </div>
                :
                <></>
          }
          {
            this.props.selected.model &&
              this.props.selected.motor &&
              this.props.selected.transmission ?
                <div>
                  <select
                    value={this.props.selected.drive || 0}
                    onChange={(event) => this.select(event, 'drive')}
                  >
                    <option value={0} key={0} disabled={true} hidden={true}>Привод</option>
                    {this.getDriveSelectOptions()}
                  </select>
                </div>
                :
                <></>
          }
        </div>
        {
          this.props.selected.model &&
            this.props.selected.motor &&
            this.props.selected.transmission &&
            this.props.selected.drive ?
              <div className='periodic-maintenance-select'>
                <h5>Периодическое обслуживание</h5>
                <div>
                  <select
                    value={this.props.selected.pm || 0}
                    onChange={(event) => this.select(event, 'pm')}
                  >
                    <option value={0} key={0} disabled={true} hidden={true}>Периодическое обслуживание</option>
                    {this.getPMSelectOptions()}
                  </select>
                </div>
              </div>
              :
              <></>
        }
        {/*{*/}
        {/*  this.props.selected.model &&*/}
        {/*    this.props.selected.motor &&*/}
        {/*    this.props.selected.transmission &&*/}
        {/*    this.props.selected.drive &&*/}
        {/*    this.props.selected.pm ?*/}
        {/*    <div className='labor-time'>*/}
        {/*      <h5>{`Для прохождения ${this.props.selected.pm} потребуется ${this.props.pmData?.labortime || '???'} нормо-часа`}</h5>*/}
        {/*    </div>*/}
        {/*    :*/}
        {/*    <></>*/}
        {/*}*/}
        {
          this.props.selected.model &&
            this.props.selected.motor &&
            this.props.selected.transmission &&
            this.props.selected.drive &&
            this.props.selected.pm ?
              <div className='write-pm-form'>
                <h5>Записаться на ТО</h5>
                <div>
                  <input
                    type='text'
                    placeholder='Фамилия'
                    value={this.props.writeForPMData['surname']}
                    onChange={(event) => this.props.onInputChange('surname', event.target.value)}
                  />
                  <input
                    type='text'
                    placeholder='Имя'
                    value={this.props.writeForPMData['name']}
                    onChange={(event) => this.props.onInputChange('name', event.target.value)}
                  />
                  <input
                    type='text'
                    placeholder='Отчество'
                    value={this.props.writeForPMData['patronymic']}
                    onChange={(event) => this.props.onInputChange('patronymic', event.target.value)}
                  />
                  <input
                    type='text'
                    placeholder='Гос. номер'
                    value={this.props.writeForPMData['car_number']}
                    onChange={(event) => this.props.onInputChange('car_number', event.target.value)}
                  />
                  <InputMask
                    type='text'
                    placeholder='Телефон'
                    mask="+375(99)999-99-99"
                    maskChar="_"
                    value={this.props.writeForPMData['phone']}
                    onChange={(event) => this.props.onInputChange('phone', event.target.value)}
                  />
                </div>
                <div className='button-container'>
                  <button onClick={() => this.props.onPMWrite()}>
                    Записаться
                  </button>
                </div>
              </div>
                :
              <></>
            }
      </div>
    </div>
  }
}